

















































import { Component, Prop, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import FeedbackIcon from '@/components/icons/Feedback.vue';

import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';
import FeedbackService from '@/api/FeedbackService';
import Rating from '@/components/molecules/Rating/Rating.vue';
import SuccessFeedback from '@/components/icons/SuccessFeedback.vue';
import segmentIo from '@/utils/segment.io';

const providerReviewUrl = {
  wix:
    'https://www.wix.com/app-market/add-review/e436abee-b736-4ecc-a7ec-0ee182afe9e8',
  shopify: 'https://apps.shopify.com/twism#modal-show=ReviewListingModal',
  bigcommerce: 'https://www.bigcommerce.com/apps/twism-loyalty-rewards/',
  woocommerce: 'https://wordpress.org/plugins/twism/#reviews'
};

type TProviderName = 'wix' | 'shopify' | 'bigcommerce' | 'woocommerce';

@Component({
  components: {
    FilledButton,
    FeedbackIcon,
    Rating,
    SuccessFeedback
  }
})
export default class Review extends Vue {
  @Prop({ default: 0 }) defaultRating!: number;
  @Prop({ default: false }) hasSendFeedback!: boolean;
  @Prop({ default: false }) email!: boolean;
  @Prop() sendFeedback!: Function;
  serviceBusiness = new BusinessService();
  serviceFeedback = new FeedbackService();
  rating = 0;
  comment: string = '';
  success = false;
  loading = false;

  get tPrefix() {
    return 'common.components.feedback';
  }

  get tSuccessPrefixTitle() {
    if (this.hasSendFeedback) return 'registered_';
    return '';
  }

  get tSuccessPrefix() {
    if (this.hasSendFeedback) return 'registered_';
    if (this.rating === 5) return `${this.provider as TProviderName}_`;
    if (this.email) return 'email_';
    return '';
  }

  get business() {
    if (!this.$store.getters['business/getBusinessInfo']) return {};
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  changeRate(rate: number) {
    segmentIo.track(
      `Changed ${this.email ? 'Email ' : ''}Feedback Platform Rate`,
      { rate }
    );
    this.rating = rate;
  }

  changeComment(comment: string) {
    this.comment = comment;
  }

  async onSubmit() {
    try {
      this.loading = true;
      await this.sendFeedback({
        rating: this.rating,
        comment: this.comment,
        provider: this.provider
      });
      const business = {
        ...this.business,
        hasSendFeedback: true
      };
      eventBus.$emit('setBusinessInfo', business);
      if (!this.email)
        this.$store.dispatch('business/SET_BUSINESS_INFO', business);

      this.$emit('success');

      this.success = true;
    } finally {
      this.loading = false;
    }
  }

  get provider() {
    if (this.$route.query.provider) return this.$route.query.provider;
    if (this.$store.getters['merchant/getCurrentProvider']) {
      return this.$store.getters['merchant/getCurrentProvider'].name;
    }

    return 'wix';
  }

  onSuccessClick() {
    if (this.hasSendFeedback) {
      segmentIo.track(
        `Clicked ${this.email ? 'Email ' : ''}Feedback Platform Support`
      );
      window.open('https://support.twism.com/hc/en-us/requests/new', '_blank');
      return;
    }

    if (this.rating === 5) {
      segmentIo.track(
        `Clicked ${this.email ? 'Email ' : ''}Feedback Platform Provider`,
        {
          provider: this.provider
        }
      );
      window.open(providerReviewUrl[this.provider as TProviderName], '_blank');
    }

    this.$emit('successClick');
  }

  created() {
    this.rating = Number(this.defaultRating);
  }
}
